import createIcon from '../../createIcon';

/**
 * @component @name PlayForWork
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNC41VjEwLjA5SDcuNUwxMiAxNC41OUwxNi41IDEwLjA5SDEzVjQuNUgxMVpNNiAxMy41QzYgMTYuODEgOC42OSAxOS41IDEyIDE5LjVDMTUuMzEgMTkuNSAxOCAxNi44MSAxOCAxMy41SDE2QzE2IDE1LjcxIDE0LjIxIDE3LjUgMTIgMTcuNUM5Ljc5IDE3LjUgOCAxNS43MSA4IDEzLjVINloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlayForWork = createIcon('PlayForWork', [
  [
    'path',
    {
      d: 'M11 4.5V10.09H7.5L12 14.59L16.5 10.09H13V4.5H11ZM6 13.5C6 16.81 8.69 19.5 12 19.5C15.31 19.5 18 16.81 18 13.5H16C16 15.71 14.21 17.5 12 17.5C9.79 17.5 8 15.71 8 13.5H6Z',
      key: '198e99',
    },
  ],
]);

export default PlayForWork;
